var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.034 23.992v.001l-.006.007.006-.008ZM9.464 9.037a2.536 2.536 0 0 1 2.531-2.531 2.536 2.536 0 0 1 2.531 2.531 2.536 2.536 0 0 1-2.53 2.531 2.536 2.536 0 0 1-2.532-2.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.034 23.992 7.211-9.542c1.15-1.527 1.791-3.298 1.844-5.122v-.284a8.98 8.98 0 0 0-2.723-6.47A8.99 8.99 0 0 0 11.83.003C7.045.108 3.172 3.942 3 8.72v.264c-.013 1.924.648 3.867 1.85 5.466l7.184 9.542ZM7.917 9.044a4.084 4.084 0 0 0 4.078 4.078 4.084 4.084 0 0 0 4.078-4.078 4.084 4.084 0 0 0-4.078-4.078 4.084 4.084 0 0 0-4.078 4.078Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LocationFilled.16d668d8b5988ac2b19de57657f72006.svg";